export enum FeriproGender {
  MALE = "m",
  FEMALE = "w",
  DIVERSE = "d",
}
